import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { getProject } from '../data/projectData';

const ProjectDetailPage = () => {
  const { projectId } = useParams();
  const project = getProject(projectId);

  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.substring(1);
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [projectId]);

  if (!project) {
    return (
      <div className="bg-white font-sans">
        <Header />
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-premium-dark mb-4">Project Not Found</h1>
            <Link to="/" className="text-premium-gold hover:underline">Return Home</Link>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="bg-white font-sans">
      <Header />
      
      {/* Hero Section */}
      <section className="relative h-[70vh] min-h-[500px] overflow-hidden">
        <img
          src={project.heroImage}
          alt={project.title}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-premium-dark/70 via-premium-dark/20 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-8 sm:p-16">
          <div className="max-w-7xl mx-auto">
            <div className="inline-block bg-premium-gold px-4 py-2 mb-4">
              <span className="text-premium-dark font-semibold text-sm tracking-wider uppercase">
                {project.subtitle}
              </span>
            </div>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-4">
              {project.title}
            </h1>
          </div>
        </div>
      </section>

      {/* Project Overview */}
      <section className="py-16 sm:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16">
            <div className="lg:col-span-2">
              <h2 className="font-display text-3xl sm:text-4xl font-bold text-premium-dark mb-6">
                Project Overview
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed mb-8">
                {project.overview}
              </p>
            </div>
            
            {/* Project Details Sidebar */}
            <div className="lg:col-span-1">
              <div className="bg-premium-light p-8 rounded-lg sticky top-24">
                <h3 className="font-display text-xl font-bold text-premium-dark mb-6 pb-4 border-b border-gray-200">
                  Project Details
                </h3>
                <div className="space-y-4">
                  <div>
                    <div className="text-sm text-gray-500 uppercase tracking-wider mb-1">Project Type</div>
                    <div className="text-premium-dark font-semibold">{project.details.type}</div>
                  </div>
                  <div>
                    <div className="text-sm text-gray-500 uppercase tracking-wider mb-1">Location</div>
                    <div className="text-premium-dark font-semibold">{project.details.location}</div>
                  </div>
                  {project.details.floor && (
                    <div>
                      <div className="text-sm text-gray-500 uppercase tracking-wider mb-1">Floors</div>
                      <div className="text-premium-dark font-semibold">{project.details.floor}</div>
                    </div>
                  )}
                  {project.details.duration && (
                    <div>
                      <div className="text-sm text-gray-500 uppercase tracking-wider mb-1">Duration</div>
                      <div className="text-premium-dark font-semibold">{project.details.duration}</div>
                    </div>
                  )}
                  {project.details.completed && (
                    <div>
                      <div className="text-sm text-gray-500 uppercase tracking-wider mb-1">Completed</div>
                      <div className="text-premium-dark font-semibold">{project.details.completed}</div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProjectDetailPage;
